export const STATUTS = [
  { value: "nouveau", label: "Nouveau" },
  { value: "contacte", label: "Contacté" },
  { value: "interesse", label: "Intéressé" },
  { value: "rdv", label: "RDV pris" },
  { value: "gagne", label: "Gagné" },
  { value: "perdu", label: "Perdu" },
];

export const PRIORITES = [
  { value: "basse", label: "Basse" },
  { value: "normale", label: "Normale" },
  { value: "haute", label: "Haute" },
];

export const LOCALISATIONS = [
  { value: "dakar", label: "Dakar" },
  { value: "diaspora", label: "Diaspora" },
  { value: "autre", label: "Autre" },
];

export const TYPE_APPARTS = [
  { value: "studio", label: "Studio" },
  { value: "f2", label: "F2" },
  { value: "f3", label: "F3" },
  { value: "f4", label: "F4" },
  { value: "f5+", label: "F5+" },
  { value: "autre", label: "Autre" },
];

export const HORIZONS = [
  { value: "maintenant", label: "Dès maintenant" },
  { value: "1-3mois", label: "1-3 mois" },
  { value: "3-6mois", label: "3-6 mois" },
  { value: "6mois+", label: "6 mois +" },
  { value: "inconnu", label: "Non défini" },
];

export const PROCEDURE_STEPS = [
  { key: "contacted_24h", label: "Contacté < 24h" },
  { key: "catalog_sent", label: "Catalogue envoyé" },
  { key: "plans_sent", label: "Plans envoyés" },
  { key: "rdv_fixed", label: "RDV fixé" },
  { key: "rdv_done", label: "RDV effectué" },
  { key: "financing_sent", label: "Simulation envoyée" },
  { key: "offer_made", label: "Offre transmise" },
  { key: "closing", label: "Closing / Signature" },
];

export const BUCKET_META = {
  hot: {
    label: "HOT",
    color:
      "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-900/50",
    dot: "bg-red-500",
    full: "Priorité absolue · décision rapide",
  },
  warm: {
    label: "WARM",
    color:
      "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900/50",
    dot: "bg-amber-500",
    full: "Intérêt fort · 1-3 mois",
  },
  nurture: {
    label: "NURTURE",
    color:
      "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900/50",
    dot: "bg-emerald-500",
    full: "À cultiver · 3-6 mois",
  },
  won: {
    label: "GAGNÉ",
    color:
      "bg-violet-50 text-violet-700 border-violet-200 dark:bg-violet-950/40 dark:text-violet-300 dark:border-violet-900/50",
    dot: "bg-violet-500",
    full: "Vente conclue",
  },
  lost: {
    label: "PERDU",
    color:
      "bg-zinc-100 text-zinc-500 border-zinc-200 dark:bg-zinc-900 dark:text-zinc-500 dark:border-zinc-800",
    dot: "bg-zinc-400",
    full: "Opportunité perdue",
  },
  pending: {
    label: "EN ATTENTE",
    color:
      "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950/40 dark:text-blue-300 dark:border-blue-900/50",
    dot: "bg-blue-500",
    full: "À qualifier",
  },
};

export const statutLabel = (v) =>
  STATUTS.find((s) => s.value === v)?.label || v;

export const prioriteLabel = (v) =>
  PRIORITES.find((p) => p.value === v)?.label || v;

export const horizonLabel = (v) =>
  HORIZONS.find((h) => h.value === v)?.label || v;

export const typeAppartLabel = (v) =>
  TYPE_APPARTS.find((t) => t.value === v)?.label || v;

export const localisationLabel = (v) =>
  LOCALISATIONS.find((l) => l.value === v)?.label || v;

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatDateShort = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
  });
};

export const formatDateTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const daysSince = (iso) => {
  if (!iso) return Infinity;
  const d = new Date(iso);
  if (isNaN(d)) return Infinity;
  return Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
};

export const hoursSince = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d)) return null;
  return (Date.now() - d.getTime()) / (1000 * 60 * 60);
};

export const isDueToday = (iso) => {
  if (!iso) return false;
  return iso.slice(0, 10) === todayISO();
};

export const isOverdue = (iso) => {
  if (!iso) return false;
  return iso.slice(0, 10) < todayISO();
};

/**
 * Bucket classification : HOT / WARM / NURTURE / WON / LOST / PENDING.
 *
 * v2.1.0 — uses max(manual_score, auto_score). The auto_score is computed
 * server-side on every lead response (4 signaux : budget / réactivité /
 * procedure avancée / AI quality). A commercial can override either way :
 *   - poser 4 étoiles manuelles → HOT même si auto_score = 0
 *   - le système peut faire monter un lead HOT tout seul si tous les
 *     signaux sont au vert, sans qu'on touche aux étoiles.
 *
 * The frontend mirrors the backend bucket_from logic so the badge on a
 * lead card matches what the dashboard counts.
 */
export const bucketOf = (lead) => {
  if (lead.statut === "gagne") return "won";
  if (lead.statut === "perdu") return "lost";
  const manual = lead.score || 0;
  const auto = lead.auto_score || 0;
  const s = Math.max(manual, auto);
  if (s >= 4) return "hot";
  if (s === 3) return "warm";
  if (s >= 1) return "nurture";
  return "pending";
};

/**
 * v2.1.0 — Effective score (manual ∨ auto). Used wherever the UI needs to
 * compare against a threshold (e.g. show "🔥 lead chaud" pill).
 */
export const effectiveScore = (lead) =>
  Math.max(lead?.score || 0, lead?.auto_score || 0);

/** v2.1.0 — French labels for auto_signals keys returned by the backend. */
export const AUTO_SIGNAL_LABELS = {
  budget_high: "Budget élevé (≥ 50M FCFA)",
  reactive: "Répondu sur WhatsApp dans les 24h",
  advanced: "Contacté & catalogue envoyé",
  ai_high: "Score qualité AI élevé",
};

export const isPrioritaire = (lead) => {
  if (lead.statut === "gagne" || lead.statut === "perdu") return false;
  if (isDueToday(lead.prochaine_action) || isOverdue(lead.prochaine_action))
    return true;
  // v2.1.0 — effective score = max(manuel, auto) so the priority pill
  // surfaces leads that the auto-score detected as HOT even without
  // a manual rating.
  if (lead.priorite === "haute" || effectiveScore(lead) >= 4) return true;
  if (daysSince(lead.derniere_action) > 2) return true;
  return false;
};

export const priorityReason = (lead) => {
  const reasons = [];
  if (isOverdue(lead.prochaine_action)) reasons.push("Relance en retard");
  else if (isDueToday(lead.prochaine_action))
    reasons.push("Relance aujourd'hui");
  if ((lead.score || 0) >= 4) reasons.push("Score HOT");
  else if (lead.priorite === "haute") reasons.push("Priorité haute");
  if (daysSince(lead.derniere_action) > 2) reasons.push("Sans contact > 2j");
  return reasons;
};

export const statutColor = (statut) => {
  switch (statut) {
    case "nouveau":
      return "bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300";
    case "contacte":
      return "bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300";
    case "interesse":
      return "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300";
    case "rdv":
      return "bg-violet-50 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300";
    case "gagne":
      return "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300";
    case "perdu":
      return "bg-zinc-100 text-zinc-500 dark:bg-zinc-900 dark:text-zinc-500";
    default:
      return "bg-zinc-100 text-zinc-700";
  }
};

export const prioriteColor = (priorite) => {
  switch (priorite) {
    case "haute":
      return "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-900/50";
    case "normale":
      return "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/30 dark:text-amber-300 dark:border-amber-900/50";
    case "basse":
      return "bg-zinc-50 text-zinc-600 border-zinc-200 dark:bg-zinc-900 dark:text-zinc-400 dark:border-zinc-800";
    default:
      return "";
  }
};

export const getInitials = (nom) => {
  if (!nom) return "?";
  return nom
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || "")
    .join("");
};

export const hoursLeft24 = (created_at) => {
  const h = hoursSince(created_at);
  if (h === null) return null;
  return Math.max(0, 24 - h);
};

export const isUrgent = (lead) => {
  // HOT lead not yet contacted within 24h
  if (lead.statut !== "nouveau") return false;
  if ((lead.score || 0) < 4) return false;
  if (lead.procedure?.contacted_24h) return false;
  return true;
};

export const isStale = (lead) => {
  // Any active lead without contact for > 2 days
  if (lead.statut === "gagne" || lead.statut === "perdu") return false;
  return daysSince(lead.derniere_action) > 2;
};

export const formatFCFA = (amount) => {
  if (!amount || amount <= 0) return "0 FCFA";
  if (amount >= 1_000_000_000) return `${(amount / 1_000_000_000).toFixed(1)} Md FCFA`;
  if (amount >= 1_000_000) return `${(amount / 1_000_000).toFixed(0)} M FCFA`;
  if (amount >= 1_000) return `${(amount / 1_000).toFixed(0)} k FCFA`;
  return `${amount} FCFA`;
};

export const formatCountdown = (hours) => {
  if (hours === null || hours === undefined) return "—";
  if (hours <= 0) return "En retard";
  const h = Math.floor(hours);
  const m = Math.floor((hours - h) * 60);
  return `${h}h ${m.toString().padStart(2, "0")}m`;
};

export const programmeProgress = (programme) => {
  if (!programme || programme.length === 0) return 0;
  const done = programme.filter((p) => p.fait).length;
  return Math.round((done / programme.length) * 100);
};
